<span
	*ngIf="tag"
	class="monty-tag monty-tag-{{ tag }}"
	[class.monty-tag-open]="open"
	[matTooltip]="'MONTY.tag_' + tag | translate | capitalize"
	>{{ tag }}</span
>
